import { useState, useEffect } from 'react';
import { getCallDuration } from '@pages/Admin/Campaign/ui/utils';
import { CampaignCallStatus } from '@shared/constants/recipient-status.constants';
import { CallData, CallDetailsState } from '../types';

const initialState: CallDetailsState = {
  answered: false,
  callDuration: '',
  callsStatus: '',
  callCreation: new Date() as Date | null,
};

export const useCallDetails = (call: CallData, startCallTime?: Date): CallDetailsState => {
  const [callDetails, setCallDetails] = useState<CallDetailsState>(initialState);

  useEffect(() => {
    if (call) {
      const { status, endedAt, startedAt } = call;

      const endedAtForCallInProgress =
        status === CampaignCallStatus['IN-PROGRESS'] ? undefined : endedAt;

      let callDuration =
        startedAt && endedAt ? getCallDuration(startedAt, endedAtForCallInProgress) : null;

      setCallDetails({
        answered: !!startedAt,
        callDuration: callDuration ?? '',
        callCreation: startCallTime || null,
        callsStatus: status || '',
      });
    }
  }, [call, startCallTime]);

  return callDetails;
};
